import Utility from "app/horoscope/utility/utility";
import React from "react";
import PropTypes from "prop-types";
import { tableStyleCompact, thStyleCompact, tdStyleCompact, sectionTitleStyle } from "./printTableStyles";

export default function AspectRashiTable({ aspectData }) {
    return (
        <div>
            <div style={sectionTitleStyle}>
                රාශි දෘෂ්ටි
            </div>
            <table style={tableStyleCompact}>
                <thead>
                    <tr>
                        <th style={thStyleCompact}>-</th>
                        <th style={thStyleCompact}>ග්‍රහයා</th>
                        <th style={thStyleCompact}>තැන්පත් රාශිය</th>
                        <th style={thStyleCompact}>දෘෂ්ටි ලද රාශි</th>
                        <th style={thStyleCompact}>දෘෂ්ටි ලද භාව</th>
                        <th style={thStyleCompact}>දෘෂ්ටි ලද ග්‍රහයෝ</th>
                    </tr>
                </thead>
                <tbody>
                    {aspectData.map((row, idx) => (
                        <tr key={idx}>
                            <td style={tdStyleCompact}><p dangerouslySetInnerHTML={{ __html: `${Utility.getPlanetSymbol(row.planet)}` }} /></td>
                            <td style={tdStyleCompact}>{row.planet}</td>
                            <td style={tdStyleCompact}>{row.rasi}</td>
                            <td style={tdStyleCompact}>{row.aspectedRasis}</td>
                            <td style={tdStyleCompact}>{row.aspectedHouses}</td>
                            <td style={tdStyleCompact}>{row.aspectedPlanets}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    AspectRashiTable.propTypes = {
        aspectData: PropTypes.arrayOf(PropTypes.object).isRequired,
    };
}